/**
 * 模板最新最热排序选择
 * @author liangxin
 * @since 19/03/12
 */

import * as qs from '@fe/common/lib/query-string';
import Logger from '@fe/logger';
import * as storeFilters from 'actions/store-filters';
import classnames from 'classnames';
import VARIABLES from 'constants/variable.json5';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import store from 'store';
import { updateSearchUrlFilterData } from 'utils/common';
import { sendToClickSortType } from 'utils/stat';
import './sort-switch.less';
const logger = Logger.get('store:search-label-list');
const { setSubmitFilters } = storeFilters;
const sortType = [
  {
    index: 0,
    text: '综合排序',
  },
  {
    index: 1,
    text: '最新',
  },
];

const searchCategory = {
  RECOMMEND: '1',
  RP_H5: '2',
  RP_SPA: '3',
  RP_VIDEO: '4',
  SEARCH: '9',
  RP_STORE: '12',
  SHOWPAGE: '5',
  POSTER: '15',
  OPENZONE: '',
};

export default class SearchAppType extends Component {
  static propTypes = {
    category: PropTypes.string,
    // 更新筛选参数
    filterChange: PropTypes.func,
    // 设置平台专区mostHot
    setMostHot: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      // 是否显示切换排序
      isVisiable: false,
      // 选中下标值
      activeIndex: 0,
    };
  }

  componentDidMount() {
    this.isShowSortSwitch();
    const queryObj = qs.parse(window.location.search) || {};
    const { filters } = queryObj;
    let mostHot;
    let index;
    try {
      mostHot = JSON.parse(decodeURIComponent(filters)).mostHot;
    } catch (error) {
      logger.error(error);
    }
    if (mostHot || mostHot === undefined) {
      index = 0;
    } else {
      index = 1;
    }
    this.setState({
      activeIndex: index,
    });
  }

  componentWillReceiveProps(nextProps) {
    // 收藏模板隐藏切换排序
    if (
      nextProps.category !== this.props.category &&
      nextProps.category === VARIABLES.MY_TPL
    ) {
      this.setState({ isVisiable: false });
    }
  }

  // 是否显示切换排序
  isShowSortSwitch = () => {
    let visiable = true;
    if (Object.keys(searchCategory).indexOf(this.props.category) === -1) {
      visiable = false;
    } else {
      visiable = true;
    }
    this.setState({ isVisiable: visiable });
  };

  // 切换最新或最热排序
  handleSortType = item => {
    const { filterChange, category, setMostHot } = this.props;
    let mostHot = true;
    this.setState({ activeIndex: item.index }, () => {
      if (+item.index === sortType[0].index) {
        mostHot = true;
      } else {
        mostHot = false;
      }
      // 切换排序埋点(平台专区暂不埋点)
      category !== VARIABLES.OPENZONE &&
        sendToClickSortType(mostHot ? 1 : 2, searchCategory[category]);
      filterChange && filterChange({ mostHot });
      // 更新搜索页 关键词
      updateSearchUrlFilterData('mostHot', mostHot);
      // 平台专区保存排序状态
      setMostHot({ mostHot });
      store.dispatch(setSubmitFilters({ isUrlParam: false }));
    });
  };

  // 渲染最新最热排序
  renderSortType() {
    const { activeIndex } = this.state;
    return (
      <div className="sort-switch-button">
        {sortType.map(item => (
          <a
            className={classnames({
              item: true,
              active: item.index === activeIndex,
            })}
            key={item.index}
            onClick={this.handleSortType.bind(this, item)}>
            {item.text}
          </a>
        ))}
      </div>
    );
  }

  render() {
    const { isVisiable } = this.state;
    return (
      isVisiable && (
        <div className="sort-switch-container">{this.renderSortType()}</div>
      )
    );
  }
}
